
require('./prototypes/Array.js');
require('./prototypes/Date.js');
require('./prototypes/Object.js');
require('./prototypes/String.js');

import Config from '../config/config';

//Setting the venue list url to be used globally
window.venues_change_url = Config.venues_list_url;

window.secure = {
    token: undefined,
    auth: undefined,
};

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to the kings camp api.
 * ES6 Promise Polyfill for IE11
 * https://github.com/mzabriskie/axios/blob/master/UPGRADE_GUIDE.md#es6-promise-polyfill
 */
require('es6-promise').polyfill();
window.axios = require('axios');

/*=================================================
 Bearer Authentication Token
 */

var base_domain = Config.base_domain;

function getCookie(name) {
    name += '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
}

function setCookie(name, value, expiry) {
	//Expiry time should be UTC
	var date = null;
	if((expiry ^ 0) === expiry) {
        var d = new Date();
        date = (new Date((d.getTime()) + (Math.abs(expiry) * 1000))).toUTCString();
    } else {
        date = expiry - offset;
    }

    var path = base_domain.slice(base_domain.lastIndexOf('/') - base_domain.length).replace(/\/$/, "");

    // set the cookie with samesite=none
    document.cookie = name + "=" + value + "; expires=" + date + "; path=" + path + "; samesite=none; secure";

    //document.cookie = name+'=' + value + ";expires="+date+";path="+path+(window.location.protocol === 'https:' ? ';secure' : '');

    //console.log(name+'=' + value + ";expires="+date+";path="+path+(window.location.protocol === 'https:' ? ';secure' : ''));
    return date;
}
/**
 * Retrieving the bearer token for authenticion on the rest-api.
 */
function getToken() {
    $.ajax({
        async: false,
        url: Config.api_base+'system/oauth2/token',
        method: 'POST',
        data: JSON.stringify({
            client_id: Config.client_id,
            client_secret: Config.client_secret,
            audience: Config.token_audience,
            scopes: [
                'camp-booking',
                'system'
            ]
        }),
    }).done(function (response) {
        window.secure.token = response.data;

        /**
         * Storing the refresh token in local storage for the user.
         */
        var access_expires = setCookie('kingscamps_access_token', window.secure.token['access_token'], window.secure.token['expires_in']);
        setCookie('kingscamps_refresh_token', window.secure.token['refresh_token'], window.secure.token['refresh_expires_in']);


        axios.defaults.headers.common = {
            Authorization: "Bearer: " + window.secure.token['access_token'],
            // "Cache-Control": "max-age=1000"
        };

        //Resetting the booking id as this is a new session
        setCookie('kingscamps_booking_id', '', 0);
        setCookie('kingscamps_booking_user_id', '', 0);
    });
}

/**
 * Handling the refresh token
 *
 * @param refresh_token
 */
function refreshToken( refresh_token ) {
    $.ajax({
        async: false,
        url: Config.api_base+'system/oauth2/refresh',
        method: 'POST',
        data: JSON.stringify({
            refresh_token: refresh_token.replace('"', '')
        }),
    }).done(function (response) {
        window.secure.token = response.data;

        axios.defaults.headers.common = {
            Authorization: window.secure.token['token_type'] + ": " + window.secure.token['access_token'],
            // "Cache-Control": "max-age=1000"
        };

        /**
         * Storing the refresh token in local storage for the user.
         */
        var access_expires = setCookie('kingscamps_access_token', window.secure.token['access_token'], window.secure.token['expires_in']);
        setCookie('kingscamps_refresh_token', window.secure.token['refresh_token'], window.secure.token['refresh_expires_in']);
    }).fail(function () {
        getToken();
    });
}

/**
 * Calling the intiial refresh token to initiate the above loop.
 */
function determineToken() {
    var access_token = getCookie('kingscamps_access_token');
    var refresh_token = getCookie('kingscamps_refresh_token');

    if(access_token && refresh_token) {
        //There is a token that hasn't expired
        window.secure.token = {
            access_token,
            refresh_token
        }
        //Setting the axios Authorization header
        axios.defaults.headers.common = {
            Authorization: "Bearer: " + access_token,
        };
    } else if(refresh_token) {
        //There is no token but there is a refresh token we can use to refresh the missing token
        refreshToken(refresh_token);
    } else {
        //There is no token data stored so we'll have to generate a new session
        getToken();
    }

	//return false;
    return window.secure.token['access_token'];
}

determineToken();
/*=================================================
 HTTP Library (Axios)
 */

/**
 * Giving the defaults for all axios to save time (and code) writing them for
 * all requests.
 *
 * @type {{Authorization: string}}
 */
axios.defaults.withCredentials = true;
axios.defaults.baseURL = Config.api_base;
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    var token = determineToken();
    config.headers.Authorization = "Bearer: " + token;
    return config;
  });

/*=================================================
 Modules
 */

/**
 * Defining all the modules for the api
 */
export default {
    venues: require('./modules/venues'),
}



// WEBPACK FOOTER //
// ./src/api/api.js